export default __webpack_public_path__ + "static/media/icon-star.d0cbd94e.png";